export const getLocationInfo = () => {
  const { hostname, port } = window?.location;

  if (hostname === 'localhost') return { region: 'localhost', port };

  const split = hostname.split('.');
  return { service: split[0], region: split[1] || 'xx' };
};
